import {FaPencilAlt, FaTrash} from "react-icons/fa";
import {getUrl} from "../../../constants/urls";

export const groupListURL = getUrl("listGroup");

export const ACTION_LIST = [
  {label: "Edit", icon: FaPencilAlt, perms: ["change_group"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_group"]},
];

export const PERMS_FOR_ACTIONS = ["change_group", "delete_group"];

export const LIST_HEADERS = ["id", "total_user_count", "name"];

const groupTableColumns = {
  Name: "name",
};

export const getColumnValue = (label) => {
  return groupTableColumns[`${label}`];
};
